import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  scrollContainer: {
    display: 'grid',
    flex: 1,
    minHeight: 0,
    padding: `${theme.new.spacing.medium} 0`,
    '& > div': {
      minHeight: 0,
    },
  },
  tablePaper: {
    border: `1px solid ${theme.new.color.line.hairline}`,
  },
}));

export default useStyles;
